import { addStar } from '@/constants'
import { IAppApplication } from '@/app/application'
import { PageNames } from '@/classes/types'

export function installGlobalProperties(app: IAppApplication): void {
  app.setGlobalProperty('$requiredLabel', function (this: { $t(key: string): string }, key: string): string {
    return addStar(this.$t(key))
  })

  app.setGlobalProperty('PageNames', PageNames)
}
